module.exports = __webpack_public_path__ + "static/media/52870018-67cs2Sgs.b242786c.JPG";